import { render, staticRenderFns } from "./modal-notification-body.vue?vue&type=template&id=6bf22b08&scoped=true&lang=pug"
import script from "./modal-notification-body.js?vue&type=script&lang=js&external"
export * from "./modal-notification-body.js?vue&type=script&lang=js&external"
import style0 from "./modal-notification-body.vue?vue&type=style&index=0&id=6bf22b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf22b08",
  null
  
)

export default component.exports